export default __webpack_public_path__ + "static/media/04.c9f0aa8c.jpg";